// EarPiercingsData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const earPiercings: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Ear Piercing Dubai (Best Price) Baby Ear Piercing Near Me in Dubai",
            "description": "Ear Piercing Dubai: Looking for a painless ear piercing in Dubai for your baby? We offer professional ear piercing services, ensuring a gentle, hygienic, and stress-free experience for your little one. Book now!",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/ear-piercing-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Ear Piercing Dubai (Best Price) Baby Ear Piercing Near Me in Dubai",
                "description": "Ear Piercing Dubai: Looking for a painless ear piercing in Dubai for your baby? We offer professional ear piercing services, ensuring a gentle, hygienic, and stress-free experience for your little one. Book now!",
                "url": "https://elitebodyhome.com/ear-piercing-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-27T09:34:35+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/tfesgvsgbe.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/tfesgvsgbe.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Ear Piercing Dubai",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Ear Piercing Dubai (Best Price) Baby Ear Piercing Near Me in Dubai",
                "description": "Ear Piercing Dubai: Looking for a painless ear piercing in Dubai for your baby? We offer professional ear piercing services, ensuring a gentle, hygienic, and stress-free experience for your little one. Book now!",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/tfesgvsgbe.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Ear Piercing Dubai"],
        "hero": {
            "title": "Ear Piercing Dubai",
            "subtitle": "Stylish Ears, Perfectly Pierced",
            "description": "For fashion, for tradition, or for personal expression — ear piercings have been an important cultural phenomenon across the globe. Elite Body Home Polyclinic provides professional ear piercing in Dubai with high attention to patient care and satisfaction with a safety, hygiene, and discomfort free experience."
        },
        "howItWorks": {
            "title": "",
            "description": ""
        },
        "procedureSteps": {
            "heading": "Ear Piercing Procedure",
            "para": "Elite Body Home Polyclinic aims to be fast, accurate and least painful. Alles done using the most up to date sterilised equipment and all procedures are followed with strict hygiene protocols to ensure the best results and prevent infection.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Our specialists will guide the type of ear piercing you are looking for your baby and examine all ears only to perform the process to avoid any error.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Sterilization",
                    "desc": "We minimize any risk of infection by using fully sterilized tools and pre-packaged, hypoallergenic earrings.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "Marking",
                    "desc": "A sterile pen is used to mark the spot where the piercing will be done to ensure it is accurate and symmetrical.",
                    "icon": "fa-solid fa-pen"
                },
                {
                    "title": "Piercing",
                    "desc": "A special piercing gun or needle pierces the lobe quickly and without much pain.",
                    "icon": "fa-solid fa-bolt"
                }
            ]
        },
        "benefits": {
            "heading": "Why Ear Piercing Dubai With Us?",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "Professional Service",
                    "desc": "Each piercing is done with precision and care by our professional piercers.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "State-of-the-Art Equipment",
                    "desc": "Our trained professionals pierce ears by utilizing the most latest tools, ensuring it is clean and painless.",
                    "icon": "fa-solid fa-tools"
                },
                {
                    "title": "Hygiene First",
                    "desc": "From start to finish of your piercing, we take extensive measures on sterilization and safety protocols to keep you safe.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "Comfortable Environment",
                    "desc": "Making sure you feel comfortable before, during and after the procedure no matter if you are here for your first ear pierce or have a dozen holes walking in!",
                    "icon": "fa-solid fa-couch"
                }
            ]
        },
        "eligibility": {
            "heading": "Types of Ear Piercing We Offer",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "Standard Ear Piercing.",
                    "desc": "A classic and timeless choice, our standard ear piercings are performed on the lobe for a simple yet elegant look.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "Cartilage Piercing.",
                    "desc": "For those looking for something unique, cartilage piercings on the upper ear are a trendy option",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "Baby Ear Piercing in Dubai",
                    "desc": "We specialize in safe and gentle baby ear piercings, using techniques designed to ensure minimal discomfort for your little one.",
                    "icon": "fa-solid fa-star"
                }
            ]
        },
        // "preparationTips": {
        //     "heading": "",
        //     "subheading": "",
        //     "para": "",
        //     "items": [
        //         {
        //             "title": "",
        //             "desc": "",
        //             "icon": "fa-regular fa-clock"
        //         }
        //     ]
        // },
        "results": {
            "heading": "Results",
            "subheading": "Ear Piercing Cost in Dubai",
            "para": "The cost of ear piercing in Dubai can vary based on the materials used, such as implant-grade titanium, gold, niobium, steel, silicon, and silver. At Elite Body Home, we offer a range of premium materials to suit every preference. Our ear piercing services are performed by licensed professionals, certified by the Dubai Health Authority (DHA), ensuring the highest standards of safety and care. To help you make the best choice, we offer a FREE consultationwhere our experts will guide you through the process and discuss your options. Book your free consultation today and let us help you with a safe and personalized piercing experience!",
            // "items": [
            //     {
            //         "title": "",
            //         "desc": "",
            //         "icon": ""
            //     }
            // ]
        },
        // "aftercareTips": {
        //     "heading": "",
        //     "subheading": "",
        //     "para": "",
        //     "items": [
        //         {
        //             "title": "",
        //             "desc": "",
        //             "icon": ""
        //         }
        //     ]
        // },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "What type of ear piercing is best?",
                    "answer": "The best ear piercing depends on personal style and comfort. Popular options include lobe, cartilage, and helix piercings, each with unique appeal."
                },
                {
                    "question": "When should I get my baby's ears pierced?",
                    "answer": "It's recommended to wait until your baby is at least 6 months old to ensure a safer healing process and reduced risk of infection."
                },
                {
                    "question": "How long does it take for baby ears to heal after piercing?",
                    "answer": "Baby ear piercings typically heal in 6-8 weeks with proper aftercare, although it can vary depending on the individual."
                },
                {
                    "question": "Does ear piercing hurt?",
                    "answer": "Ear piercing involves a quick, sharp pinch, but the discomfort is usually minimal and brief. Most patients describe it as similar to a small pinch."
                }
            ]
        },
        "treatmentAreas1": [
        ],
        "treatmentAreas2": [
        ]
    },
    "shared": {
        "images": {
            introductionImage: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Ear-Piercing.jpg",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/tfesgvsgbe.jpg",
            "beforeAfter": [
                'https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Ear-Piercing-Dubais-1.jpg',
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Ear-Piercing-Dubais-2.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Ear-Piercing-Dubais-3.jpg"
            ]
        },
        "product": {
            "id": 129,
            "title": "Ear Piercing",
            "price": 399,
            "description": "Ear Piercing Dubai: Looking for a painless ear piercing in Dubai for your baby? We offer professional ear piercing services, ensuring a gentle, hygienic, and stress-free experience for your little one. Book now!"
        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "ثقب الأذن في دبي (أفضل سعر) | ثقب أذن الأطفال بالقرب مني في دبي",
            "description": "ثقب الأذن في دبي: هل تبحث عن ثقب أذن غير مؤلم لطفلك في دبي؟ نقدم خدمات ثقب أذن احترافية، مع ضمان تجربة لطيفة ونظيفة وخالية من التوتر لطفلك. احجز الآن!",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/ear-piercing-dubai/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "ثقب الأذن في دبي (أفضل سعر) | ثقب أذن الأطفال بالقرب مني في دبي",
                "description": "ثقب الأذن في دبي: هل تبحث عن ثقب أذن غير مؤلم لطفلك في دبي؟ نقدم خدمات ثقب أذن احترافية، مع ضمان تجربة لطيفة ونظيفة وخالية من التوتر لطفلك. احجز الآن!",
                "url": "https://elitebodyhome.com/services/ear-piercing-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-27T09:34:35+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/tfesgvsgbe.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/tfesgvsgbe.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "ثقب الأذن في دبي",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "ثقب الأذن في دبي (أفضل سعر) | ثقب أذن الأطفال بالقرب مني في دبي",
                "description": "ثقب الأذن في دبي: هل تبحث عن ثقب أذن غير مؤلم لطفلك في دبي؟ نقدم خدمات ثقب أذن احترافية، مع ضمان تجربة لطيفة ونظيفة وخالية من التوتر لطفلك. احجز الآن!",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/tfesgvsgbe.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "ثقب الأذن في دبي"],
        "hero": {
            "title": "ثقب الأذن في دبي",
            "subtitle": "أذنان أنيقتان، ومثقوبتان بإتقان",
            "description": "يعتبر ثقب الأذن ظاهرة ثقافية هامة في جميع أنحاء العالم، سواء كانت من أجل الموضة، أو تقليد شائع، أو للتعبير الشخصي. تقدم عيادات ايليت بودي هوم في دبي خدمة ثقب الأذن الاحترافية مع اهتمام كبير برعاية المرضى ورضاهم، وضمان تجربة آمنة وصحية وخالية من الألم."
        },
        "howItWorks": {
            "title": "",
            "description": ""
        },
        "procedureSteps": {
            "heading": "خطوات إجراء ثقب الأذن",
            "para": "تهدف عيادات ايليت بودي هوم إلى أن يكون الإجراء سريع ودقيق وأقل إيلامًا. تُستخدم أحدث المعدات المعقمة، وتُتبع جميع الإجراءات بأعلى معايير النظافة لضمان أفضل النتائج ولمنع العدوى.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "سيقوم الطبيب المتخصص بتوجيهك بشأن نوع ثقب الأذن الذي ترغب فيه لطفلك، وفحص الأذنين للتأكد من تنفيذ العملية بدقة لتجنب أي خطأ.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "التعقيم",
                    "desc": "نقلل من أي خطر للعدوى باستخدام أدوات معقمة بالكامل وحلقان أذن مُعبئة مسبقًا ومضادة للحساسية.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "تحديد مكان الثقب",
                    "desc": "يُستخدم قلم معقم لوضع علامة على المكان الذي سيتم فيه ثقب الأذن لضمان دقته وتماثله.",
                    "icon": "fa-solid fa-pen"
                },
                {
                    "title": "الثقب",
                    "desc": "تُثقب شحمة الأذن باستخدام مسدس ثقب أو إبرة خاصة بسرعة ودون ألم كبير.",
                    "icon": "fa-solid fa-bolt"
                }
            ]
        },
        "benefits": {
            "heading": "لماذا تختارنا لثقب الأذن في دبي؟",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "خدمة احترافية",
                    "desc": "يُجرى كل ثقب للأذن بدقة واهتمام من قبل متخصصين محترفين.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "معدات متطورة",
                    "desc": "يستخدم محترفونا المدربون أحدث الأدوات لضمان أن عملية الثقب تتم بطريقة نظيفة وغير مؤلمة.",
                    "icon": "fa-solid fa-tools"
                },
                {
                    "title": "النظافة أولاً",
                    "desc": "من البداية وحتى النهاية، نتخذ تدابير دقيقة للتعقيم واتباع بروتوكولات الأمان للحفاظ على سلامتك.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "بيئة مريحة",
                    "desc": "نحرص على أن تشعر بالراحة قبل وأثناء وبعد الإجراء، سواء كانت هذه هي المرة الأولى لك في ثقب الأذن أو إذا كان لديك بالفعل العديد من الثقوب!",
                    "icon": "fa-solid fa-couch"
                }
            ]
        },
        "eligibility": {
            "heading": "أنواع ثقب الأذن التي نقدمها",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "ثقب الأذن المعتاد",
                    "desc": "يتم ثقب الأذن في شحمة الأذن، ويعد خيارًا كلاسيكيًا وخالدًا للحصول على مظهر بسيط وأنيق.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "ثقب الغضروف",
                    "desc": "إذا كنت تبحث عن نوع مميز من الثقوب، فتُعد ثقوب الغضروف في الجزء العلوي من الأذن من الصيحات الرائجة.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "ثقب أذن الأطفال في دبي",
                    "desc": "تُصمم تقنيات ثقب الأذن لدينا لتوفير راحة البال، مع الالتزام بأقل ألم ممكن لطفلك.",
                    "icon": "fa-solid fa-star"
                }
            ]
        },
        // "preparationTips": {
        //     "heading": "",
        //     "subheading": "",
        //     "para": "",
        //     "items": [
        //         {
        //             "title": "",
        //             "desc": "",
        //             "icon": "fa-regular fa-clock"
        //         }
        //     ]
        // },
        "results": {
            "heading": "النتائج",
            "subheading": "تكلفة ثقب الأذن في دبي",
            "para": "تعتمد تكلفة ثقب الأذن في دبي على المواد المستخدمة مثل التيتانيوم من الدرجة الطبية، والذهب، والنيوبيوم، والفولاذ، والسيليكون، والفضة. جميع المواد التي نستخدمها مواد فاخرة، مع خيارات تتناسب مع كل ذوق في ايليت بودي هوم. تُجرى جميع ثقوب الأذن بواسطة متخصصين مرخصين من هيئة الصحة بدبي (DHA). نقدم استشارة مجانية تمامًا - بدون أي التزامات - حيث يساعدك خبراؤنا في اختيار الخيار المثالي لك. حدد موعد استشارتك المجانية ودعنا نساعدك في تجربة ثقب آمنة ومخصصة!",
            // "items": [
            //     {
            //         "title": "",
            //         "desc": "",
            //         "icon": ""
            //     }
            // ]
        },
        // "aftercareTips": {
        //     "heading": "",
        //     "subheading": "",
        //     "para": "",
        //     "items": [
        //         {
        //             "title": "",
        //             "desc": "",
        //             "icon": ""
        //         }
        //     ]
        // },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "ما هو أفضل نوع لثقب الأذن؟",
                    "answer": "يعتمد أفضل نوع لثقب الأذن على الذوق الشخصي والراحة. تشمل الخيارات الشائعة ثقب شحمة الأذن، وثقب الغضروف، وثقب الحلزون، ولكل منها جاذبيته الخاصة."
                },
                {
                    "question": "متى يجب ثقب أذن طفلي؟",
                    "answer": "يُنصح بالانتظار حتى يبلغ طفلك 6 أشهر على الأقل لضمان عملية شفاء أكثر أمانًا وتقليل خطر العدوى."
                },
                {
                    "question": "كم تستغرق عملية شفاء ثقب أذن الطفل؟",
                    "answer": "عادةً ما تلتئم ثقوب أذن الأطفال في 6-8 أسابيع مع العناية المناسبة، على الرغم من أن ذلك قد يختلف حسب الفرد."
                },
                {
                    "question": "هل ثقب الأذن مؤلم؟",
                    "answer": "يتضمن ثقب الأذن شعورًا سريعًا بالوخز، لكن الانزعاج عادة ما يكون بسيطًا وقصيرًا. يصف معظم المرضى الإحساس وكأنه قرصة صغيرة."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }

};
